export const isEmpty = array => !Array.isArray(array) || !array.length;

export const isBlank = string => !string || string.length === 0;

export const removeEmptyValues = arr => arr.filter(Boolean);
